<template>
    <div class="transcript-summary-box" v-if="transcript">
        <h3>{{ transcript.eventTitle }} Evasion %</h3>
        <div>
            {{ new Date(transcript.eventDate).toLocaleDateString() }}
        </div>
        <div class="percentage">
            <div class="large-percentage">
                {{ percentage(transcript.evasion?.evasivePercentage) }}
            </div>
            <div>
                <OutlierIndicatorText :transcript="transcript" />
            </div>
        </div>
        <div class="list">
            <div>
                <span>Questions</span> <span>{{ transcript.evasion?.questionAnswerCount ?? '-' }}</span>
            </div>
            <div>
                <span>Evasive</span> <span>{{ transcript.evasion?.evasiveQuestionAnswerCount ?? '-' }}</span>
            </div>
            <div class="alpha">
                <span>180-day Alpha</span> <span> {{ alpha }}</span>
            </div>
        </div>
    </div>
</template>
<script setup>
import { percentage } from '@/components/evasion/formats.js'
import { asyncComputed } from '@/utils/asyncComputed.js'
import { getCompanyAlpha } from '@/services/alphaService.js'
import { addDays } from '@/utils/date.js'
import OutlierIndicatorText from '@/components/evasion/OutlierIndicatorText.vue'

const props = defineProps({
    transcript: {
        type: Object,
    },
})

const alpha = asyncComputed(async signal => {
    const startDate = new Date(props.transcript.eventDate)
    const endDate = addDays(180, startDate)

    if (endDate > new Date()) {
        return 'N/A'
    }

    const alpha = await getCompanyAlpha(props.transcript.companyId, { startDate, endDate }, signal)

    return percentage(alpha?.total ?? null)
}, '-')
</script>
<style scoped>
@import '~@/components/evasion/variables.css';

.transcript-summary-box {
    display: grid;
    grid-template-columns: minmax(120px, 180px) 1fr minmax(120px, 180px);
    grid-template-rows: 1fr min-content min-content;
    gap: 8px;

    & > h3 {
        grid-column: 1 / 4;
        grid-row: 1;
    }

    & > div {
        grid-column: 1 / 4;
        grid-row: 2;
    }

    & > .percentage {
        grid-column: 1;
        grid-row: 3;
    }

    & > .list {
        grid-column: 3;
        grid-row: 3;
    }
}

.percentage {
    align-self: center;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.percentage > div {
    font-size: 32px;
}

.list {
    display: flex;
    flex-direction: column;

    & > * {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 8px 0;
    }

    & > :nth-child(n + 2) {
        border-top: 1px solid var(--color-primary-200);
    }
}

.no-alpha .alpha {
    display: none;
}
</style>
